import './RedeemTabs.css';

function RedeemTabs({ activeTab, onTabChange, redeemableCount, closedCount }) {
  return (
    <div className="redeem-tabs">
      <button
        type="button"
        className={`redeem-tab ${activeTab === 'redeemable' ? 'redeem-tab--active' : ''}`}
        onClick={() => onTabChange('redeemable')}
      >
        <span>Redeemable Games</span>
        {redeemableCount > 0 && <span className="redeem-tab__count">{redeemableCount}</span>}
      </button>
      <button
        type="button"
        className={`redeem-tab ${activeTab === 'closed' ? 'redeem-tab--active' : ''}`}
        onClick={() => onTabChange('closed')}
      >
        <span>Closed Games</span>
        {closedCount > 0 && <span className="redeem-tab__count">{closedCount}</span>}
      </button>
    </div>
  );
}

export default RedeemTabs;
